<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4">
  <div class="form-group row">
    <div class="col-md-6">
      <yt-fw-date-picker-popup formControlName="DatumOd" name="txtDatumOd" [Label]="'ZARADAPOMENJACNICI.DATUMOD.SINGULAR'">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.DatumOd.invalid">
        <span *ngFor="let validation of errorMessages.DatumOd">
          <span class="error-message" *ngIf="fc.DatumOd.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.DatumOd.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <yt-fw-date-picker-popup formControlName="DatumDo" name="txtDatumDo" [Label]="'ZARADAPOMENJACNICI.DATUMDO.SINGULAR'">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.DatumDo.invalid">
        <span *ngFor="let validation of errorMessages.DatumDo">
          <span class="error-message" *ngIf="fc.DatumDo.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.DatumDo.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-sm-12">
      <div class="form-check">
        <input
        style="width: 20px;"
          type="checkbox"
          class="form-check-input"
          id="cbPrikaziDonos"
          formControlName="Donos"
        >
        <label class="form-check-label" for="cbPrikaziDonos"><span translate="ZARADAPOMENJACNICI.PRIKAZIDONOS.SINGULAR"></span></label>
      </div>
    </div>           
  </div>   
 
  <div class="row mt-2">
      <div class="col-md-12">  
        <button type="button" class="btn btn-primary" (click)="LoadData()">
          Učitaj podatke
        </button>
      </div>
  </div>
</form>
<yt-fw-default-table
  *ngIf="modelData!=null && modelData.MainList!=null"
  [Config]="Config"
  [Items]="items"
  [TableColumns]="modelData.MainList.TableColumns"      
  [Condensed]="CondensedTable"
  [ShowLoader]="MainItemsLoading"
  (RefreshDataClicked)="RefreshData()"
>
</yt-fw-default-table>


